export default __webpack_public_path__ + "static/media/SpaceElevator.256.7e27b5a4.png";